import { useState } from "react";
import { basvurular, kampanyalar } from "@/mocks/dashboard";
import KullaniciDetayModal from "./KullaniciDetayModal";

const CARD_BG = "#141720";
const BORDER = "#1e2130";
const TEXT_PRIMARY = "#e8eaf0";
const TEXT_SECONDARY = "#5a5f7a";

export default function Basvurular() {
  const [seciliKullanici, setSeciliKullanici] = useState<typeof basvurular[0] | null>(null);
  const [kampanyaFiltre, setKampanyaFiltre] = useState("Tümü");
  const [whatsappFiltre, setWhatsappFiltre] = useState("Tümü");
  const [aramaMetni, setAramaMetni] = useState("");

  const filtrelenmis = basvurular.filter((b) => {
    const kampanyaUygun = kampanyaFiltre === "Tümü" || b.kampanya === kampanyaFiltre;
    const whatsappUygun = whatsappFiltre === "Tümü" || (whatsappFiltre === "Geçti" && b.whatsapp) || (whatsappFiltre === "Geçmedi" && !b.whatsapp);
    const aramaUygun = aramaMetni === "" || b.adSoyad.toLowerCase().includes(aramaMetni.toLowerCase()) || b.kampanya.toLowerCase().includes(aramaMetni.toLowerCase());
    return kampanyaUygun && whatsappUygun && aramaUygun;
  });

  const tarihFormat = (tarih: string) => {
    const d = new Date(tarih);
    const simdi = new Date();
    const fark = Math.floor((simdi.getTime() - d.getTime()) / 60000);
    if (fark < 60) return `${fark} dk önce`;
    if (fark < 1440) return `${Math.floor(fark / 60)} saat önce`;
    return `${Math.floor(fark / 1440)} gün önce`;
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-bold" style={{ color: TEXT_PRIMARY }}>Başvurular</h2>
        <p className="text-sm mt-1" style={{ color: TEXT_SECONDARY }}>Tüm lead listesi ve kullanıcı hareketleri</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[
          { label: "Toplam Başvuru", deger: basvurular.length, ikon: "ri-file-list-3-line", accent: "#7c3aed", bg: "rgba(124,58,237,0.15)" },
          { label: "Bugün Gelen", deger: 3, ikon: "ri-calendar-check-line", accent: "#10b981", bg: "rgba(16,185,129,0.15)" },
          { label: "WhatsApp'a Geçen", deger: basvurular.filter((b) => b.whatsapp).length, ikon: "ri-whatsapp-line", accent: "#22c55e", bg: "rgba(34,197,94,0.15)" },
        ].map((item, i) => (
          <div key={i} className="rounded-2xl p-4 flex items-center gap-4" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
            <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: item.bg }}>
              <i className={`${item.ikon} text-lg`} style={{ color: item.accent }}></i>
            </div>
            <div>
              <p className="text-xl font-bold" style={{ color: TEXT_PRIMARY }}>{item.deger}</p>
              <p className="text-xs" style={{ color: TEXT_SECONDARY }}>{item.label}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Filtreler */}
      <div className="rounded-2xl p-4 flex flex-wrap items-center gap-3" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
        <div className="flex items-center gap-2 flex-1 min-w-48 rounded-lg px-3 py-2" style={{ backgroundColor: "#0d0f16" }}>
          <i className="ri-search-line text-sm" style={{ color: TEXT_SECONDARY }}></i>
          <input
            type="text"
            placeholder="Ad veya kampanya ara..."
            value={aramaMetni}
            onChange={(e) => setAramaMetni(e.target.value)}
            className="bg-transparent text-sm outline-none flex-1"
            style={{ color: "#c8cad8" }}
          />
        </div>
        <select
          value={kampanyaFiltre}
          onChange={(e) => setKampanyaFiltre(e.target.value)}
          className="text-sm rounded-lg px-3 py-2 cursor-pointer outline-none"
          style={{ backgroundColor: "#0d0f16", border: `1px solid ${BORDER}`, color: "#8b8fa8" }}
        >
          <option value="Tümü">Tüm Kampanyalar</option>
          {kampanyalar.map((k) => <option key={k.id} value={k.ad}>{k.ad}</option>)}
        </select>
        <div className="flex items-center gap-1 rounded-lg p-1" style={{ backgroundColor: "#0d0f16" }}>
          {["Tümü", "Geçti", "Geçmedi"].map((f) => (
            <button
              key={f}
              onClick={() => setWhatsappFiltre(f)}
              className="px-3 py-1.5 rounded-md text-xs font-medium transition-all cursor-pointer whitespace-nowrap"
              style={{
                backgroundColor: whatsappFiltre === f ? "#1e2130" : "transparent",
                color: whatsappFiltre === f ? "#a78bfa" : TEXT_SECONDARY,
              }}
            >
              {f === "Tümü" ? "WhatsApp: Tümü" : f === "Geçti" ? "WhatsApp Geçti" : "WhatsApp Geçmedi"}
            </button>
          ))}
        </div>
      </div>

      {/* Tablo */}
      <div className="rounded-2xl overflow-hidden" style={{ backgroundColor: CARD_BG, border: `1px solid ${BORDER}` }}>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr style={{ backgroundColor: "#0d0f16", borderBottom: `1px solid ${BORDER}` }}>
                {["Ad Soyad", "Telefon", "Kampanya", "Aşama", "WhatsApp", "Tarih", "İşlem"].map((h) => (
                  <th key={h} className="text-left px-5 py-3.5 text-xs font-semibold uppercase tracking-wide" style={{ color: TEXT_SECONDARY }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtrelenmis.map((b) => (
                <tr
                  key={b.id}
                  className="transition-colors"
                  style={{ borderBottom: `1px solid ${BORDER}` }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.03)")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                >
                  <td className="px-5 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: "linear-gradient(135deg,#7c3aed,#4f46e5)" }}>
                        <span className="text-white text-xs font-bold">{b.adSoyad.split(" ").map((n) => n[0]).join("")}</span>
                      </div>
                      <p className="text-sm font-semibold" style={{ color: TEXT_PRIMARY }}>{b.adSoyad}</p>
                    </div>
                  </td>
                  <td className="px-5 py-4"><span className="text-sm font-mono" style={{ color: "#8b8fa8" }}>{b.telefon}</span></td>
                  <td className="px-5 py-4">
                    <span className="text-xs font-medium px-2.5 py-1 rounded-full" style={{ backgroundColor: "rgba(124,58,237,0.15)", color: "#a78bfa" }}>
                      {b.kampanya.length > 20 ? b.kampanya.substring(0, 20) + "..." : b.kampanya}
                    </span>
                  </td>
                  <td className="px-5 py-4">
                    <div className="flex items-center gap-2">
                      <div className="flex gap-0.5">
                        {Array.from({ length: b.toplamAsama }).map((_, j) => (
                          <div key={j} className="w-3 h-1.5 rounded-full" style={{ backgroundColor: j < b.asama ? "#7c3aed" : "#1e2130" }}></div>
                        ))}
                      </div>
                      <span className="text-xs" style={{ color: TEXT_SECONDARY }}>{b.asama}/{b.toplamAsama}</span>
                    </div>
                  </td>
                  <td className="px-5 py-4">
                    {b.whatsapp
                      ? <span className="flex items-center gap-1 text-xs font-medium" style={{ color: "#22c55e" }}><i className="ri-check-line"></i> Geçti</span>
                      : <span className="flex items-center gap-1 text-xs font-medium" style={{ color: TEXT_SECONDARY }}><i className="ri-close-line"></i> Geçmedi</span>
                    }
                  </td>
                  <td className="px-5 py-4"><span className="text-xs" style={{ color: TEXT_SECONDARY }}>{tarihFormat(b.tarih)}</span></td>
                  <td className="px-5 py-4">
                    <button
                      onClick={() => setSeciliKullanici(b)}
                      className="text-xs font-medium px-3 py-1.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                      style={{ backgroundColor: "rgba(124,58,237,0.15)", color: "#a78bfa" }}
                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "rgba(124,58,237,0.25)")}
                      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "rgba(124,58,237,0.15)")}
                    >
                      Detay Gör
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {filtrelenmis.length === 0 && (
          <div className="py-12 text-center">
            <i className="ri-file-list-3-line text-3xl block mb-2" style={{ color: "#2a2d3a" }}></i>
            <p className="text-sm" style={{ color: TEXT_SECONDARY }}>Sonuç bulunamadı</p>
          </div>
        )}
      </div>

      {seciliKullanici && <KullaniciDetayModal kullanici={seciliKullanici} onKapat={() => setSeciliKullanici(null)} />}
    </div>
  );
}
